import React from 'react';
import Header from '../Header/Header';

const Home = () => {
    return (
        <div>
            <Header></Header>
        </div>
    );
};

export default Home;